<template>
	<div class="arrowTop" @click="toTop">
        <div><img :src="`${imgPath}/static/assets/img/arrow_top.png`" /></div>
        <p>{{ $t('top') }}</p>
    </div>
</template>

<script>
	export default {
		name:'top',
		data() {
			return {
			}
		},
		computed: {
			
		},
		created() {
			
		},
		methods:{
            toTop() {
            
                let top = document.documentElement.scrollTop || document.body.scrollTop;
                // 实现滚动效果 
                const timeTop = setInterval(() => {
                    document.body.scrollTop = document.documentElement.scrollTop = top -= 200;
                    if (top <= 0) {
                    clearInterval(timeTop);
                    }
                }, 20);
            }
        }
	}
</script>
<style lang="scss" scoped>
        .arrowTop{
			width: 1rem;
            margin: 1.62rem auto 0.3rem;
			cursor: pointer;
			>div {
				width: 0.32rem;
				height: 0.19rem;
				margin: 0 auto;
				>img {
					width: 100%;
					height: 100%;
				}
			}
			>p{
				font-size: 0.18rem;
				color: #000000;
				margin-top: 0.2rem;
				text-align: center;
			}
		}
</style>


// WEBPACK FOOTER //
// src/components/top.vue